import "core-js/modules/es.array.push.js";
import api from "@/api";
export default {
  name: "XhsScriptView",
  components: {},
  data() {
    return {
      timer: null,
      timerIdx: 0,
      updateAuthorInterval: 300,
      updateNoteInterval: 600,
      watchAuthors: false,
      watchNotes: false,
      logs: [],
      debug: this.$route.query.debug
    };
  },
  methods: {
    onTimer() {
      this.timerIdx++;
      if (this.watchAuthors && this.timerIdx % this.updateAuthorInterval == 0) {
        this.updateAuthor();
      }
      if (this.watchNotes && this.timerIdx % this.updateNoteInterval == 0) {
        this.updateNote();
      }
    },
    updateAuthor() {
      api.getCareAuthorList().then(ret => {
        let authorIdx = 0;
        for (let a of ret) {
          setTimeout(() => {
            this.printLog(`检查作者 ${a.userId} , ${a.nickName} 的更新...`);
            window.open(`https://www.xiaohongshu.com/user/profile/${a.userId}?ICECMD=READ_POSTS,CLOSE_AFTER_UPDATE`, '_blank');
          }, 3000 * authorIdx);
          authorIdx++;
        }
      });
    },
    updateNote() {
      api.getXhsNotes().then(ret => {
        let cnt = 0;
        for (let note of ret) {
          if (note.noteId) {
            this.printLog(`检查笔记 ${note.noteId} , ${note.title} 的更新...`);
            setTimeout(() => {
              window.open(`https://www.xiaohongshu.com/explore/${note.noteId}?ICECMD=CLOSE_AFTER_UPDATE`, '_blank');
            }, cnt * 2000);
            cnt += 1;
          }
        }
      });
    },
    printLog(t) {
      this.logs.push(this.getCurrentDateTime() + ' ' + t);
      setTimeout(() => {
        const scrollContainer = this.$refs.console;
        scrollContainer.$el.scrollTop = scrollContainer.$el.scrollHeight;
      }, 200);
    },
    getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    init() {
      api.getSystemConfig('AUTHOR_UPDATE_INTERVAL,NOTE_UPDATE_INTERVAL').then(ret => {
        this.updateAuthorInterval = ret['AUTHOR_UPDATE_INTERVAL'] ? parseInt(ret['AUTHOR_UPDATE_INTERVAL']) : 10;
        this.updateNoteInterval = ret['NOTE_UPDATE_INTERVAL'] ? parseInt(ret['NOTE_UPDATE_INTERVAL']) : 20;
      });
      this.timer = setInterval(this.onTimer, 1000);
    }
  },
  mounted() {
    this.init();
  },
  unmounted() {
    clearInterval(this.timer);
  }
};